import { Col, Form, Modal, Row, Switch, TimePicker, Typography } from 'antd';
import React, { Fragment, useEffect } from 'react';
import { weekLongOptions } from '../../constants';
import dayjs from 'dayjs';

const BusinessHours = ({ open, onClose, data, onSubmit }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    const formattedData = weekLongOptions.map(({ value: day }) => {
      return {
        day,
        enabled: values[day]?.enabled || false,
        openTime: values[day]?.openTime?.format('HH:mm') || null,
        closeTime: values[day]?.closeTime?.format('HH:mm') || null,
      };
    });
    onSubmit(formattedData);
    onClose();
  };

  useEffect(() => {
    if (data) {
      const initialValues = {};
      data.forEach(({ day, enabled, openTime, closeTime }) => {
        initialValues[day] = {
          enabled,
          openTime: openTime ? dayjs(openTime, 'HH:mm') : null,
          closeTime: closeTime ? dayjs(closeTime, 'HH:mm') : null,
        };
      });
      form.setFieldsValue(initialValues);
    }
  }, [data]);

  return (
    <Modal
      title="Opening Hours"
      open={open}
      onCancel={onClose}
      centered
      styles={{
        mask: {
          backdropFilter: 'blur(4px)',
          backgroundColor: '#00000015',
        },
        content: {
          borderRadius: '12px',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
        },
      }}
      okText="Save"
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={handleFinish}>
        <Row gutter={[16, 16]} style={{ display: 'flex', alignItems: 'center' }}>
          {weekLongOptions.map(({ label, value: day }) => {
            return (
              <Fragment key={day}>
                <Col span={6}>
                  <Typography.Title level={5}>{label}</Typography.Title>
                </Col>
                <Col span={4}>
                  <Form.Item
                    name={[day, 'enabled']}
                    valuePropName="checked"
                    style={{ marginBottom: 0 }}
                  >
                    <Switch />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    name={[day, 'openTime']}
                    style={{ marginBottom: 0 }}
                    dependencies={[day, 'enabled']}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const enabled = getFieldValue([day, 'enabled']);
                          if (enabled && !value) {
                            return Promise.reject(new Error(''));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <TimePicker format="HH:mm" placeholder="Open Time" minuteStep={5} />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    name={[day, 'closeTime']}
                    style={{ marginBottom: 0 }}
                    dependencies={[day, 'enabled']}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const enabled = getFieldValue([day, 'enabled']);
                          if (enabled && !value) {
                            return Promise.reject(new Error(''));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <TimePicker format="HH:mm" placeholder="Close Time" minuteStep={5} />
                  </Form.Item>
                </Col>
              </Fragment>
            );
          })}
        </Row>
      </Form>
    </Modal>
  );
};

export default BusinessHours;
